import Glide from '@glidejs/glide'

import {VideoModal, TransitionClass, DisableIfSingleSlide} from 'PlugAndPlay/_global/js/glideExtensions'

class EventDetailsCarousel {

    settings = {

        type: 'carousel',


    }

    constructor(element) {

        // Define the carousel HTML element for use throughout the class
        this.carousel = element;

        this.initialiseCarousel();

    }

    initialiseCarousel() {

        this.glideCarousel = new Glide(this.carousel, this.settings).mount({

            'TransitionClass': TransitionClass,
            'VideoModal': VideoModal,
            'DisableIfSingleSlide': DisableIfSingleSlide,
            
        });

    }

}




document.addEventListener("DOMContentLoaded", function () {

    let elEventDetailsCarousel = document.querySelector(".event-details-carousel");

    if (elEventDetailsCarousel) {
        
        let elEventDetailsCarouselInstance = new EventDetailsCarousel(elEventDetailsCarousel);

    }

});

